import axios from "axios";
import { OrderTrackingInfo_API_URL } from "./config";

export const OrdersAPI = () => {
  const env_var = process.env.NODE_ENV;

  return {
    orderTrackingInfo: (req, res) =>
      axios
        .get(OrderTrackingInfo_API_URL, { params: req })
        .then((response) => {
          res = response.data;
          return res;
        })
        .catch((err) => {
          if (env_var === "development") {
            console.log("Development mode enabled");
            console.log("Order-Tracking:ERROR " + err.message);
          } else if (env_var === "production") {
            console.log("Order-Tracking:ERROR - Unknown Error ");
          }
        }),
  };
};
